<template>
  <div class="crew-members-list">
    <h3 class="mb-4 page-header-2">Crew Members</h3>
    <div>
      <ButtonToggle
        v-model="activeFilter"
        class="my-2"
        :options="options"
      ></ButtonToggle>
      <Checkbox
        v-model="allDepts"
        label="Include All Departments"
        class="my-4"
      ></Checkbox>
      <text-field
        v-model="search"
        class="full-width mb-4"
        label="Quick Finder"
        hint-label="(Search by name)"
        placeholder=" "
      ></text-field>
    </div>
    <div class="draggable-list-cont overflow-scroll">
      <draggable-crew-members-list
        :crew-members="filteredCrewMembers"
        @assign="handleAssign"
      ></draggable-crew-members-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import ButtonToggle from "@/components/ButtonToggle.vue";
import Checkbox from "@/components/Checkbox.vue";
import TextField from "@/components/TextField.vue";
import DraggableCrewMembersList from "./DraggableCrewMembersList.vue";

export default {
  components: {
    DraggableCrewMembersList,
    TextField,
    Checkbox,
    ButtonToggle
  },
  data() {
    return {
      search: "",
      allDepts: false,
      activeFilter: "active",
      options: [
        {
          value: "active",
          label: "Active"
        },
        {
          value: "all",
          label: "All"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      filteredCrewMembers({ crewMembers, department }) {
        return crewMembers.filter((member) => {
          const searchMatch =
            !this.search ||
            (member.full_name || "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1;
          const activeOnly = this.activeFilter === "all" || !member.archived;
          const deptFilter =
            this.allDepts || member.department.id === department.id;
          return searchMatch && activeOnly && deptFilter;
        });
      }
    })
  },
  methods: {
    ...mapActions(["assignCrewMember"]),
    handleAssign({ crewMember, technicianId }) {
      this.assignCrewMember({
        link: crewMember.links.crew_member_assign,
        technicianId,
        memberId: crewMember.id
      }).finally(() => {
        EventBus.$emit("refresh-work-crews");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.crew-members-list {
  width: 250px;
  flex-shrink: 0;
  height: 100%;
  overflow-y: hidden;
  padding-left: 1%;
}
.draggable-list-cont {
  height: 70%;
  overflow-x: hidden;
}
</style>
